import * as Sentry from "@sentry/nextjs";
import { useState } from "react";
import axios from "axios";
import { DebounceInput } from "react-debounce-input";
import SuggestedResultList from "./SuggestedResultList";
import InfoMessage from "./InfoMessage";
import styles from "./CompanySearch.module.scss";
import SkeletonSuggestedResultList from "./skeletons/SkeletonSuggestedResultList";
import resizeIframe from "../helpers/resizeIframe";
import OstermeloAdditionalInformation from "./OstermeloAdditionalInformation";

export default function CompanySearch({ searchEndpoint }) {
  const [suggestedResults, setSuggestedResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [abortController, setAbortController] = useState();
  const [searchTerm, setSearchTerm] = useState();
  const [companyType, setCompanyType] = useState("company");

  /**
   * Get suggested search options from the api
   * @param {string} search search term
   */
  const runSearch = async (search) => {
    // reset state when there is no search term
    if (!search) {
      setLoading(false);
      setSuggestedResult([]);
      setSearchTerm("");
      return;
    }

    setLoading(true);
    setSearchTerm(search);
    // abort previous request
    if (abortController) {
      abortController.abort();
    }

    try {
      const controller = new AbortController();
      setAbortController(controller);
      // get suggested results from the api
      const rapidSearchAPIEndpoint = searchEndpoint === "opten" ? "/api/rapidSearchOpten" : "/api/rapidSearchCegjelzo";
      const response = await axios.get(`${rapidSearchAPIEndpoint}?search=${search}&companyType=${companyType}`, { signal: controller.signal });
      setSuggestedResult(response.data.result);
      setLoading(false);
      setTimeout(() => {
        resizeIframe();
      }, 1000);
    } catch (error) {
      if (error.message !== "canceled") {
        Sentry.captureException(error);
        alert("Hiba a keresés közben. Kérem, várjon pár percet és próbálja újra");
        console.error(error);
      }
    }
  };

  return (
    <>
      <div className={styles.companyTypeOptions}>
        <button
          className={`${styles.companyTypeOption} ${companyType === "company" ? styles.companyTypeOptionActive : null}`}
          onClick={() => {
            setCompanyType("company");
            if (searchTerm) {
              runSearch(searchTerm);
            }
          }}
        >
          Társas vállalkozás (Kft, Bt)
        </button>
        <button
          className={`${styles.companyTypeOption} ${companyType === "all" ? styles.companyTypeOptionActive : null}`}
          onClick={() => {
            setCompanyType("all");
            if (searchTerm) {
              runSearch(searchTerm);
            }
          }}
        >
          Egyéni vállalkozás
        </button>
        <button
          className={`${styles.companyTypeOption} ${companyType === "ostermelo" ? styles.companyTypeOptionActive : null}`}
          onClick={() => {
            setCompanyType("ostermelo");
          }}
        >
          Őstermelő
        </button>
      </div>
      {companyType === "ostermelo" ? (
        <OstermeloAdditionalInformation />
      ) : (
        <>
          <div className={styles.searchForm}>
            <DebounceInput
              minLength={3}
              placeholder={companyType === "company" ? "Keresés cégnév szerint" : "Keresés egyéni vállalkozó neve szerint"}
              onChange={(e) => runSearch(e.target.value)}
              debounceTimeout={1000}
            />
            <div className={styles.suggestedResults}>
              {loading ? (
                <div className={styles.loading}>
                  <SkeletonSuggestedResultList />
                </div>
              ) : null}
              {!loading && searchTerm && <SuggestedResultList results={suggestedResults} cegjelzo={searchEndpoint === "cegjelzo"} />}
            </div>
          </div>
          {!searchTerm ? <InfoMessage text="Kezdje el begépelni a keresett vállalkozás nevét" /> : null}
        </>
      )}
    </>
  );
}
